const locationChoice = document.getElementById('size-chart--location-select');

const locationData = {
  1: {
    name: 'United States',
    sizes: ['US 0', 'US 2', 'US 4', 'US 6', 'US 8', 'US 10', 'US 12'],
  },
  2: {
    name: 'United Kingdom',
    sizes: ['UK 4', 'UK 6', 'UK 8', 'UK 10', 'UK 12', 'UK 14', 'UK 16'],
  },
  3: {
    name: 'Europe',
    sizes: ['', 'EU 30', 'EU 30', 'EU 32', 'EU 34', 'EU 36', 'EU 38', 'EU 40', 'EU 42', 'EU 44'],
  },
  4: {
    name: 'Italy',
    sizes: ['IT 36', 'IT 38', 'IT 40', 'IT 42', 'IT 44', 'IT 46', 'IT 48'],
  },
  5: {
    name: 'France',
    sizes: ['FR 32', 'FR 34', 'FR 36', 'FR 38', 'FR 40', 'FR 42', 'FR 44'],
  },
  6: {
    name: 'Australia',
    sizes: ['AU 4', 'AU 6', 'AU 8', 'AU 10', 'AU 12', 'AU 14', 'AU 16'],
  },
  7: {
    name: 'China',
    sizes: [
      '',
      'CN 145/73A',
      'CN 150/76A',
      'CN 150/76A',
      'CN 155/80A',
      'CN 160/84A',
      'CN 165/88A',
      'CN 170/92A',
      'CN 175/96A',
      'CN 180/100A',
    ],
  },
};

const initValues = () => {
  if (!locationChoice) return;
  index = 0;
  let selectedOptionIndex = locationChoice.selectedIndex;
  locationChoice.querySelectorAll('option').forEach((element) => {
    if (element.text == selectedVCitem) {
      selectedOptionIndex = index;
      locationChoice.selectedIndex = index;
    }
    index++;
  });
  var selectedOption = locationChoice.options[selectedOptionIndex].value;
  const locationText = document.querySelector('.size-chart--location');
  const locationSizes = document.querySelectorAll('.popup--right-value');

  if (locationData[selectedOption]) {
    if (locationData[selectedOption].name == 'United States') {
      document.querySelector('.size-chart--container').classList.add('hide-3th-column');
    }
    const data = locationData[selectedOption];
    locationText.textContent = data.name;

    locationSizes.forEach((item, index) => {
      item.textContent = data.sizes[index];
    });
  }
};
const updateValues = () => {
  if (!locationChoice) return;
  index = 0;
  let selectedOptionIndex = locationChoice.selectedIndex;
  var selectedOption = locationChoice.options[selectedOptionIndex].value;
  const locationText = document.querySelector('.size-chart--location');
  const locationSizes = document.querySelectorAll('.popup--right-value');
  if (locationData[selectedOption]) {
    if (locationData[selectedOption].name == 'United States') {
      document.querySelector('.size-chart--container').classList.add('hide-3th-column');
    } else {
      document.querySelector('.size-chart--container').classList.remove('hide-3th-column');
    }
    const data = locationData[selectedOption];
    locationText.textContent = data.name;
    locationSizes.forEach((item, index) => {
      item.textContent = data.sizes[index];
    });
  }
};
window.addEventListener('DOMContentLoaded', () => {
  initValues();
});
locationChoice &&
  locationChoice.addEventListener('change', () => {
    updateValues();
  });
